import { mapState, mapActions } from 'pinia';
import { useAuctionsBaseStore } from '../../store/landAuctionsBase';

export default {
    data() {
        return {
            dropdownList: [
                { text: '8', value: '8' },
                { text: '12', value: '12' },
                { text: '16', value: '16' },
            ],
        };
    },
    computed: {
        ...mapState(useAuctionsBaseStore, [
            'landPageCnt',
            'navPageSize',
            'navRecordCount',
            'currentPage',
            'pageCount',
            'items',
            'sort'
        ])
    },
    methods: {
        ...mapActions(useAuctionsBaseStore, [
            'changePage',
            'changePageSize',
            'updateSort'
        ]),
        changePageSizeSelector(n, noAgency = false) {
            if (n.target.value) {
                this.changePageSize(+n.target.value, noAgency);
            }
        },
    }
};
